export interface AccrualPeriodRequest {
  periodStartDate: string;
  periodEndDate: string;
  payPeriodsPerYear: number;
}

/** A calendar month is one of twelve accrual periods in a year. */
export const MONTHS_PER_YEAR = 12;

function isoDate(d: Date): string {
  // Local calendar parts, not toISOString(): that converts to UTC and shifts the date by a day
  // for users ahead of UTC.
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${String(d.getFullYear()).padStart(4, '0')}-${mm}-${dd}`;
}

/**
 * Builds the accrue request for the calendar month containing `now`. The period type and the
 * period count are defined together here so they cannot drift apart: a calendar-month period
 * always posts payPeriodsPerYear = 12.
 */
export function buildMonthlyAccrualRequest(now: Date): AccrualPeriodRequest {
  return {
    periodStartDate: isoDate(new Date(now.getFullYear(), now.getMonth(), 1)),
    periodEndDate: isoDate(new Date(now.getFullYear(), now.getMonth() + 1, 0)),
    payPeriodsPerYear: MONTHS_PER_YEAR,
  };
}
